import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type ThemeFilterQueryVariables = Types.Exact<{
  filters: Types.ThemeFilters;
  sort?: Types.InputMaybe<Array<Types.SortType> | Types.SortType>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Float']['input']>;
}>;


export type ThemeFilterQuery = { themes?: { totalCount: number, pageInfo?: { hasNextPage?: boolean | null, endCursor?: string | null } | null, edges?: Array<{ node: { id: string, name: string } }> | null } | null };


export const ThemeFilterDocument = /*#__PURE__*/ gql`
    query themeFilter($filters: ThemeFilters!, $sort: [SortType!], $after: String, $first: Float) {
  themes(filters: $filters, sort: $sort, first: $first, after: $after) {
    totalCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

export function useThemeFilterQuery(options: Omit<Urql.UseQueryArgs<ThemeFilterQueryVariables>, 'query'>) {
  return Urql.useQuery<ThemeFilterQuery, ThemeFilterQueryVariables>({ query: ThemeFilterDocument, ...options });
};